import React from 'react';
import radium from 'radium';
import './RadioSelection.scss';
import {ThemeContext} from '../theme/Theme.jsx';

interface RadioSelectionProps {
	name: string,
	value: string,
	radioGroupValue?: string,
	label: any,
	onChange: any,
	labelStyle?: any,
	disabled?: boolean
}

function RadioSelection(props: RadioSelectionProps) {
	const context = React.useContext(ThemeContext);
	const style: any = {
		selected: {
			fontWeight: 'bold',
		},
		default: {
			fontWeight: 'normal',
			":hover": {
				cursor: "pointer",
			},
		},
		disabled: {
			color: context.themeManager.value('radio-button', 'color', 'fg-color-text-disabled'),
			":hover": {
				cursor: "not-allowed",
			},
		},
	};

	const {
		name,
		value,
		onChange,
		radioGroupValue,
		label,
		disabled,
		labelStyle
	} = props;

	const randomId = parseInt(String(Math.random() * 100000), 10);
	const labelStyleSelected:any = radioGroupValue === value && !disabled ? style.selected : {}
	const labelStyleDisabled:any = disabled ? style.disabled : {}
	const labelStyleCompl:any = {...labelStyleDisabled, ...style.default, ...labelStyle, ...labelStyleSelected}
	
	return (
		<div className="radio__selection" style={disabled ? style.disabled : null} key="radio">
			<input
				id={name + randomId}
				type="radio"
				name={name}
				value={value}
				checked={radioGroupValue === value && !disabled}
				onChange={onChange}
				disabled={disabled}
				className="radio__button"
			/>
			<label
				htmlFor={name + randomId}
				style={labelStyleCompl}
			>{label}</label>
		</div>
	);
}

const RadiumRadioSelection = radium(RadioSelection);

export default RadiumRadioSelection;
